/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Jewelry(props) {
  return (
    <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.812 3.33301C15.1313 3.33301 15.4201 3.41646 15.6772 3.58301C15.9345 3.74967 16.1393 3.97224 16.2915 4.25L17.854 7.35449C17.9234 7.46555 17.9686 7.58716 17.9897 7.71875C18.0108 7.85029 18.0216 7.97906 18.021 8.10449C18.021 8.29882 17.9894 8.48654 17.9272 8.66699C17.865 8.84741 17.7715 9.01431 17.646 9.16699L11.271 16.792C11.1043 16.9864 10.9092 17.1358 10.687 17.2402C10.4649 17.3445 10.2355 17.3961 9.99951 17.3955C9.76355 17.3954 9.5341 17.3441 9.31201 17.2402C9.08995 17.1364 8.89558 16.9868 8.729 16.792L2.354 9.16699C2.2291 9.01434 2.13595 8.84738 2.07373 8.66699C2.01154 8.48654 1.97959 8.29882 1.979 8.10449C1.979 7.97949 1.99012 7.85042 2.01123 7.71875C2.03237 7.58732 2.07724 7.46599 2.146 7.35449L3.7085 4.25C3.86127 3.97227 4.06654 3.74965 4.32373 3.58301C4.58072 3.41662 4.86849 3.33308 5.18701 3.33301H14.812ZM9.1665 14.7295V9.16699H4.5415L9.1665 14.7295ZM10.8335 14.7295L15.4585 9.16699H10.8335V14.7295ZM3.9585 7.5H6.1665L7.4165 5H5.2085L3.9585 7.5ZM8.021 7.5H11.979L10.729 5H9.271L8.021 7.5ZM13.8335 7.5H16.0415L14.7915 5H12.5835L13.8335 7.5Z"
        fill="#35424F"
      />
    </svg>
  )
}

Jewelry.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Jewelry
